export default __webpack_public_path__ + "locales/ro/Payments.json?hash=6c6fb66ece2cf8b1e1b97f75e63bc099";